import ApolloClientProvider from "../providers/ApolloClientProvider";
import LanguageProvider from "../providers/LanguageProvider";
import { useLoggedInSync } from "../api/firebaseAuth";
import { useEffect } from "react";
import { amplitude } from "../api/third-party";

export default function AppLayout({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) {
  const initialLoading = useLoggedInSync();
  useEffect(() => {
    const from = new URLSearchParams(location.search).get("from");
    const referral = new URLSearchParams(location.search).get("referral");
    const firstOpen = !localStorage.getItem("firstOpen");
    if (firstOpen) {
      localStorage.setItem("firstOpen", new Date().toISOString());
    }
    amplitude.logEvent("Web:Client:App:Load", {
      firstOpen,
      from: from ?? "webapp",
      referral: referral ?? undefined,
    });
  }, []);
  return (
    <ApolloClientProvider>
      <LanguageProvider>
        <div className="text-black">{!initialLoading && children}</div>
      </LanguageProvider>
    </ApolloClientProvider>
  );
}
